
import { Component, Output, OnInit ,Input} from '@angular/core';
import { NgModule } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';

import { IonApp, IonContent, IonRippleEffect } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import {defined,consts} from '../appDefs';
@Component({
  selector: 'app-open',
  templateUrl: './open.component.html',
  styleUrls: ['./open.component.scss'],
})
export class OpenComponent implements OnInit {
emptyFunBoard=true;
funBoards=[];
templates=[];
newDoc=false;
  constructor(private modalCntrl:ModalController,private httpClient:HttpClient,private toastController:ToastController) { }
 mode="board";
ngOnInit() {

  // load existing boards
    let funBoards=JSON.parse(localStorage.getItem(consts.MY_FUN_BOARD));
    if (!funBoards)
    funBoards=[];
    this.newDoc=this.emptyFunBoard=!(funBoards.length > 0);
    this.funBoards=funBoards;


    // load templates
      try {
        this.httpClient.get("/assets/boardTemplates/all.json").subscribe(data =>{
          console.log(data);
          if (data && typeof(data)=='object')
          {
        
            ( data as Array<any>).forEach(board=>{
                try {
                  this.httpClient.get("/assets/boardTemplates/"+board).subscribe(board=>
                    {
                      this.templates.push(board);
                    });
                  }
                  catch (e)
                  {
                    console.log("template "+board+"     could not be loaded");
                  }
            
                });
      
          }

        });
      }
      catch (e)
      {
        console.log("template all.json   could not be loaded");
      }
      if (this.funBoards.length==0) this.presentToast();
    
}
async presentToast() {
  const toast = await this.toastController.create({
    message: 'No saved boards found.Consider using New option under menu for new boards/songs.',
    duration: 2000,
    position:'top',
    color:'primary'
  });
  toast.present();
}



  
  getFunBoardList()
  {

   return this.funBoards;
  }

  // all template names are stores in asset all.json

getTemplateList()
{

    
  return (this.templates)
}
  open (item)
  {
    this.modalCntrl.dismiss(item);
  }

  cancel ()
  {
   
    this.modalCntrl.dismiss();
  }
 createFromTemplate(template)
 {
  this.modalCntrl.dismiss(template);

 }
 itemImage(item)
 {
   if (item.imageUrl)
    return ('/assets/icon/'+item.imageUrl);

   let file="grand_piano.png";
   if (item.currentBoard.search('double-piano')!=-1)
   {
     file="doublepiano.png"
   }
   else if (item.currentBoard.search('flex'))
   {
     file="smallflex.png"
   }
  return ("/assets/icon/"+file);
 }
 }

